import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Button, Row, Col, Modal } from 'react-bootstrap';
import Confirm from '../../components/Modal/Confirm';

import Loading from '../../components/Loading/Loading';
import { getDashboards, resyncDashboard, cleanupDashboard } from './AccountsActions';

import resyncIcon from '../../assets/images/resync.svg';
import deleteIcon from '../../assets/images/delete-icon.svg';
import deviceHub from '../../assets/images/device-hub.svg';
import clearAll from '../../assets/images/clear-all.svg';
import syncProblem from '../../assets/images/sync-problem.svg';
import layersClear from '../../assets/images/layers-clear.svg';
import '../../assets/styles/_table.scss';

class Dashboards extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sortDir: 'desc',
    };
  }

  toggleSort = () => {
    this.setState((prev) => ({ sortDir: prev.sortDir === 'asc' ? 'desc' : 'asc' }));
  };

  componentDidMount() {
    this.props.getDashboards(this.props.match.params.id);
  }

  renderRow = (data, i) => {
    return (
      <tr key={i}>
        {/* Col 1 */}
        <td>
          <p>{data.name}</p>
        </td>
        <td>
          <p>{data.board}</p>
        </td>
        {!!data.selectedArea && (
          <td>
            <p>{data.selectedArea}</p>
          </td>
        )}
        <td>
          <p>{data._id}</p>
        </td>

        {/* Col 5 */}
        <td style={{width: '780px'}}>
          <div className='d-flex flex-wrap gap-1'>
            <Button onClick={() => this.setState({ [`modal_${i}`]: true })} variant='secondary' size='sm'>
              <img src={deviceHub} alt="Dashboard mapping" /> Dashboard mapping
            </Button>

            <Confirm
              body={
                <p>
                  Are you sure you want to clean up <br />
                  {data.name} dashboard?
                </p>
              }
              confirmText="Clean up"
              icon={deleteIcon}
              title="Clean up dashboard"
              onConfirm={() => this.props.cleanup(this.props.match.params.id, data._id)}
            >
              <Button variant='secondary' size='sm'><img src={clearAll} alt="Clean up dashboard" /> Clean up dashboard</Button>
            </Confirm>

            <Confirm
              body={
                <p>
                  Are you sure you want to resync <br />
                  {data.name} dashboard?
                </p>
              }
              confirmText="Resync"
              icon={resyncIcon}
              title="Resync dashboard"
              onConfirm={() => this.props.resync(this.props.match.params.id, data._id)}
            >
              <Button variant='secondary' size='sm'><img src={syncProblem} alt="Resync dashboard" /> Resync dashboard</Button>
            </Confirm>

            <Confirm
              body={
                <p>
                  Are you sure you want to wipe out <br />
                  {data.name} dashboard?
                </p>
              }
              confirmText="Wipe out"
              icon={resyncIcon}
              title="Wipe out dashboard"
              onConfirm={() => this.props.wipeout(this.props.match.params.id, data._id)}
            >
              <Button variant='secondary' size='sm'><img src={layersClear} alt="Wipe out dashboard" /> Wipe out dashboard</Button>
            </Confirm>
          </div>
        </td>

        <Modal show={this.state[`modal_${i}`]} onHide={() => this.setState({ [`modal_${i}`]: false })}>
          <Modal.Header closeButton>
            <h2 className="mb-0">Open dashboard mapping</h2>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Row className='row-item'>
                {/* Col 2 */}
                <Col className="col-border-right">
                  {_.map(data.todo, (l, li) => {
                    return (
                      <p>
                        <span key={li}>{l}</span>
                      </p>
                    );
                  })}
                </Col>

                {/* Col 3 */}
                <Col className="col-border-right">
                  {_.map(data.wip, (l, li) => {
                    return (
                      <p>
                        <span key={li}>{l}</span>
                      </p>
                    );
                  })}
                </Col>

                {/* Col 4 */}
                <Col className="col-border-right">
                  {_.map(data.done, (l, li) => {
                    return (
                      <p>
                        <span key={li}>{l}</span>
                      </p>
                    );
                  })}
                </Col>
              </Row>
            </div>
          </Modal.Body>
        </Modal>
      </tr>
    );
  };

  render() {
    const { isLoading, dashboards } = this.props;
    const { sortDir } = this.state;
    const sortedDashboards = _.orderBy(dashboards, [(d) => d.name?.toLowerCase()], [sortDir]);
    return [
      <Helmet key="0" title="Dashboards" />,
      <div className='table-content'>
        <div className='table-filter'>
          <h2>Dashboards</h2>
        </div>
          
        {isLoading && (
          <div className='table-loading'>
            <Loading />
          </div>
        )}
        {!isLoading && dashboards.length === 0 && (
          <div className='no_data'>
            <p> No data available </p>
          </div>
        )}

        <div className='table'>
          <table>
            <thead>
              <tr>
                <th onClick={this.toggleSort} className='sortable'>
                  Name <span className='sort-icon'>{sortDir === 'asc' ? '↓' : '↑'}</span>
                </th>
                <th>Board</th>
                {sortedDashboards.some((d) => !!d.selectedArea) &&
                  <th>Area Path</th>
                }
                <th>Id</th>
                <th style={{width: '100px'}}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {!isLoading && _.map(sortedDashboards, (data, i) => this.renderRow(data, i))}
            </tbody>
          </table>
        </div>
       
      </div>,
    ];
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getDashboards: (id, opt) => dispatch(getDashboards(id, opt)),
    resync: (accId, dashboardId) => dispatch(resyncDashboard(accId, dashboardId)),
    cleanup: (accId, dashboardId) => dispatch(cleanupDashboard(accId, dashboardId)),
    wipeout: (accId, dashboardId) => dispatch(resyncDashboard(accId, dashboardId, true)),
  };
};

function mapStateToProps(state) {
  return {
    dashboards: state.accounts.dashboards,
    isLoading: state.accounts.isLoading,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboards));
